import { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const AuthRedirector = () => {
  const { currentUser, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run this effect once auth state and loading are determined
    if (loading) return;

    const currentPath = location.pathname;
    const isAuthPage = currentPath === '/auth';
    const isCompleteProfilePage = currentPath === '/complete-profile';
    const isRestroomDeepLinkPage = currentPath.startsWith('/restroom/');

    // List of public paths that don't require authentication
    const publicPaths = [
      '/',
      '/auth',
      '/qrcode',
      '/download',
      '/socials',
      '/inappinvite',
      '/ambassador',
      '/privacy-policy'
    ];

    const isPublicPath = publicPaths.includes(currentPath) || isRestroomDeepLinkPage;

    // Case 1: No user is logged in
    if (!currentUser) {
      // If not on a public page, redirect to auth
      if (!isPublicPath) {
        navigate('/auth', { replace: true, state: { from: location } });
      }
      return; // Exit if no user
    }

    // Case 2: User is logged in (currentUser is an object)
    // If profile is not complete and not already on the complete profile page
    if (currentUser && !currentUser.profileComplete && !isCompleteProfilePage) {
      navigate('/complete-profile', { replace: true });
      return;
    }

    // If profile is complete, check for deep link redirection BEFORE other redirects
    if (currentUser && currentUser.profileComplete) {
      const redirectRestroomId = sessionStorage.getItem('redirectRestroomId');
      if (redirectRestroomId) {
        sessionStorage.removeItem('redirectRestroomId');
        console.log('[AuthRedirector] Found redirectRestroomId, navigating to /app with selectedRestroomId:', redirectRestroomId);
        navigate('/app', { state: { selectedRestroomId: redirectRestroomId }, replace: true });
        return;
      }
    }

    // If user is logged in, profile is complete, and they are on an auth-related page, redirect to app
    if (currentUser && currentUser.profileComplete && (isAuthPage || isCompleteProfilePage)) {
      console.log('[AuthRedirector] User on auth page, navigating to /app');
      navigate('/app', { replace: true });
      return;
    }
  }, [currentUser, loading, navigate, location]);

  return null; // This component doesn't render anything
};

export default AuthRedirector;
